export const BE_URL = process.env.NODE_ENV === 'production' ? 'https://tool-social.weegroup.vn' : 'https://tool-social.weegroup.vn';
export const API_URL = `${BE_URL}/api`
export const HMM_API_URL = `${BE_URL}/hmm-api`
export const FILE_API_URL = 'https://sfs.vuxify.com/api';

